/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration"
import { CancelToken } from "axios";
const controller = 'Files';

const convertToPdf = (file: File, cancelToken?: CancelToken): Promise<File> => {
    const formData = new FormData();
    formData.append("file", file);

    return axiosInstance.post(`${controller}/ConvertToPdf`, formData, {
        cancelToken: cancelToken,
        headers: { "Content-Type": "multipart/form-data" },
        responseType: "blob"
    })
        .then(result => {
            const contentDisposition = result.headers?.["content-disposition"] as string | undefined;
            const match = contentDisposition?.match(/filename\*?=(?:UTF-8''|")?([^";]+)"?/i);
            const serverFileName = match?.[1] ? decodeURIComponent(match[1]) : "documento.pdf";
            return new File([result.data], serverFileName, { type: "application/pdf" });
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    convertToPdf
}